'use client';

import { useState } from 'react';

interface MobileMenuProps {
  currentPath?: string;
}

export default function MobileMenu({ currentPath }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: 'Events', href: '/#events' },
    { label: 'Specials', href: '/#specials' },
    { label: 'Hours', href: '/#hours' },
    { label: 'Crew', href: '/#crew' },
    { label: 'Galleries', href: '/galleries' },
  ];

  return (
    <div className="relative z-[80] md:hidden">
      {/* Hamburger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex flex-col justify-center items-center w-10 h-10 gap-1 focus:outline-none"
        aria-label="Menu"
      >
        <span
          className={`w-6 h-0.5 bg-yellow-500 transition-all duration-300 ${
            isOpen ? 'rotate-45 translate-y-1.5' : ''
          }`}
        />
        <span
          className={`w-6 h-0.5 bg-yellow-500 transition-all duration-300 ${
            isOpen ? 'opacity-0' : ''
          }`}
        />
        <span
          className={`w-6 h-0.5 bg-yellow-500 transition-all duration-300 ${
            isOpen ? '-rotate-45 -translate-y-1.5' : ''
          }`}
        />
      </button>

      {/* Mobile menu: full-width solid panel below header (inline bg fallback so it always paints) */}
      {isOpen && (
        <div
          className="fixed inset-0 z-[9999]"
          role="dialog"
          aria-modal="true"
          aria-label="Site menu"
        >
          <button
            aria-label="Close menu"
            className="absolute inset-0 bg-black/75"
            onClick={() => setIsOpen(false)}
          />
          <nav className="absolute right-0 top-0 h-dvh w-[78vw] max-w-[320px] border-l border-zinc-800 bg-zinc-950 px-5 pt-24 pb-8 shadow-2xl">
            <ul className="flex flex-col gap-1">
              {navItems.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={() => setIsOpen(false)}
                    className={`block rounded-md px-3 py-3 text-left text-base font-bold uppercase tracking-wider transition-colors ${
                      currentPath === item.href || currentPath?.startsWith(item.href)
                        ? 'bg-zinc-900 text-yellow-500'
                        : 'text-zinc-200 hover:bg-zinc-900 hover:text-yellow-500'
                    }`}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
}
